import React from 'react';
import ReactTypingEffect from 'react-typing-effect';
import { shuffleArray } from '../../Utils/ArrayUtils';
import tipsAndTricks from './tipsAndTricks.json';

const TipsAndTricks = (props) => {
    const shuffledTips = shuffleArray(tipsAndTricks)
    return <div style={{
        color: props.color ?? "white",
        padding: ".5em",
        maxWidth: props.maxWidth,
    }}><ReactTypingEffect
            text={shuffledTips}
            speed={0}
            eraseSpeed={0}
            typingDelay={500}
            cursor={" "}
            displayTextRenderer={(text, i) => {
                return <span><span style={{
                    fontWeight: 'bold',
                }}>Hint:</span> {text}</span>
            }}
        /></div>
}

export default TipsAndTricks